/* jshint -W071 */ // maxstatement violation. Currently no compelling reason to split up this service
angular.module('core')
  .service('classroomApi', ['$state', 'cancelableResourceFactory', 'cancelableResourceManager', 'highlightsApi', 'standardsApi', 'transformResponse', 'timeframe', 'customer', 'authentication', 'exportService', function ($state, $cancelableResourceFactory, $cancelableResourceManager, $highlightsApi, $standardsApi, $transformResponse, $timeframe, $customer, $authentication, $exportService) {
    var self = this;

    var mapRestrictionLabels = function(n) {
      var label;

      switch (n) {
        case 0:
          label = 'M';
          break;
        case 1:
          label = 'T';
          break;
        case 2:
          label = 'W';
          break;
        case 3:
          label = 'Th';
          break;
        case 4:
          label = 'F';
          break;
        case 5:
          label = 'Hours';
          break;
        default:
          label = '';
          console.error("No label mapped for code: " + n);
      }
      return label;
    };

    var mapLabels = function(id) {
      var label;

      switch (id) {
        case 'arcade_restricted':
          label = 'Arcade';
          break;
        case 'my_house_restricted':
          label = 'My House';
          break;
        case 'collections_restricted':
          label = 'Collections';
          break;
        case 'personalization_restricted':
          label = 'Personalization';
          break;
        case 'school_hours':
          label = 'School Hours';
          break;
        default:
          label = 'restricted';
          console.error("No restriction mapped for code: " + id);
      }
      return label;
    };

    var classroomSettingsMapping = function(body) {
      try {
        var classroom = JSON.parse(body);
        classroom.type = 'classroom';
        return classroom;
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var classroomEngagementMapping = function(body) {
      var result;
      try {
        result = JSON.parse(body).data.schedule;
        result = _.map(result, function(item, key) {
          if (key !== 'school_hours') {
            item.restrictions = [];
            _.forEach(item, function(n, key) {
              var day = {};
              var checked = n === 1;
              day.checked = !checked;
              day.label = mapRestrictionLabels(key);
              item.restrictions.push(day);
            });
          }
          item.id = key;
          item.label = mapLabels(key);
          return item;
        });
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        result = [];
      }
      return result;
    };

    var passwordSettingsMapping = function(body) {
      try {
        var data = JSON.parse(body).data;
        data.type = 'classroomPasswordType';
        return data;
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var classroomNavigationMapping = function(classroom) {};

    var classroomReportingMapping = function(classroom) {
      classroom.averageMonthlySessionTime = classroom.average_monthly_session_time;
      classroom.extendedUsage = classroom.percent_usage_extended_hours;
      classroom.averageGrowth = classroom.percent_growth;
    };

    var ClassroomSettings = $cancelableResourceFactory.createCacheableResource(null, '/m/classroom/:id/settings', {
      id: '@id'
    }, {
        get: {
          transformResponse: classroomSettingsMapping,
          url: '/m/classroom/:id/settings',
          method: 'GET'
        }
      }
    );

    var PasswordStyles = $cancelableResourceFactory.createCacheableResource(null, '/m/classroom/:id/authentication_type', {
        id: '@id'
      }, {
        get: {
          transformResponse: passwordSettingsMapping,
          url: '/m/classroom/:id/authentication_type',
          method: 'GET'
        }
      }
    );

    var ClassroomEngagement = $cancelableResourceFactory.createCacheableResource(null, '/m/classroom/:id/engagement_restrictions', {
        id: '@id'
      }, {
        classroom: {
          url: '/m/classroom/:id/engagement_restrictions',
          method: 'GET',
        }
      }
    );

    var classroomNavigationQuery = {
      cache: true,
      url: '/n/districts/:districtId/classrooms',
      method: 'GET',
      isArray: true,
      transformResponse: function(body) {
        return $transformResponse.transformNavigationQuery('classroom', body, classroomNavigationMapping);
      }
    };

    var classroomNavigationQueryNoCache = _.clone(classroomNavigationQuery);
    classroomNavigationQueryNoCache.cache = false;

    var ClassroomNavigation = $cancelableResourceFactory.createCacheableResource('ClassroomNavigation', '/n/districts/:districtId/classrooms', {
      id: '@id'
    }, {
      query: classroomNavigationQuery,
      queryNoCache: classroomNavigationQueryNoCache,
      getForSchool: {
        cache: true,
        url: '/n/districts/:districtId/classrooms?school_id=:schoolId',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationGet('classroom', body, classroomNavigationMapping);
        }
      },
      get: {
        cache: true,
        url: '/n/districts/:districtId/classrooms?classroom_id=:classroomId',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationGet('classroom', body, classroomNavigationMapping);
        }
      }
    });

    var classroomReportingUrl = '/r/districts/:districtId/teachers/:teacher_id/classrooms';
    var classroomUsageUrl = '/r/districts/:districtId/classrooms/:classroomId/usage';

    var ClassroomReporting = $cancelableResourceFactory.createCacheableResource('ClassroomReporting', '/r/districts/:districtId/teachers/:teacher_id/classrooms', {
      id: '@id'
    }, {
      query: {
        url: classroomReportingUrl,
        method: 'GET',
        cache: false, // without this, changing timeframe produces stale results in classrooms table
        isArray: true,
        transformResponse: function(body, headersGetter, status) {
          return $transformResponse.transformReportingQuery('classroom', body, classroomReportingMapping, status);
        }
      },
      getUsage: {
        url: classroomUsageUrl,
        method: 'GET',
        cache: false,
        isArray: false,
        transformResponse: function(body) {
          var initial = {
              usageMinutes: {
                data: [],
                xAxisLabels: []
              },
              lessons: {
                data: [],
                xAxisLabels: []
              }
            };

          try {
            var jsonBody = JSON.parse(body);
            $transformResponse.transformReportDates(jsonBody);
            var usages = jsonBody.data.usage;
            initial.numStudents = JSON.parse(body).data.num_students;
            return _.reduce(usages, function(result, usage) {
              var averageExtendedUsage = usage.average_extended_minutes;
              var averageSchoolUsage = usage.average_usage_minutes - averageExtendedUsage;
              result.usageMinutes.data.push([averageSchoolUsage, averageExtendedUsage]);
              result.usageMinutes.xAxisLabels.push(usage.label);

              result.lessons.data.push([usage.average_lessons]);
              result.lessons.xAxisLabels.push(usage.label);
              return result;
            }, initial);
          }
          catch(e) {
            console.error('Transform Error:', e.message);
            return {};
          }
        }
      }
    });

    /**************************************************************/
    /*                          Api                               */
    /**************************************************************/
    var getClassroomUsageParams = function() {
      var params = _.pick($state.params, ['districtId', 'classroomId']);

      var daysParam = $timeframe.getDaysParam();
      if (daysParam) {
        params.days = $timeframe.getDaysParam();
      } else {
        params.sy = $timeframe.getSchoolYear();
        params.fd = $timeframe.getFromDate();
        params.td = $timeframe.getToDate();
      }
      params.by = $timeframe.getByData();
      params.untilNow = true;

      return params;
    };

    self.getClassroomUsageExportUrl = function() {
      var params = getClassroomUsageParams();
      return $exportService.buildExportUrl(classroomUsageUrl, params);
    };

    self.getClassroomUsage = function() {
      var params = getClassroomUsageParams();
      var promises = ClassroomReporting.getUsage(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    var getClassroomsReportingParams = function() {
      var params = _.pick($state.params, ['districtId']);
      params.teacher_id = $state.params.teacherId;
      params.grade_id = $state.params.gradeId;
      params.school_id = $state.params.schoolId || undefined;
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      params.untilNow = true;

      return params;
    };

    self.getClassroomsReportingExportUrl = function() {
      var params = getClassroomsReportingParams();
      return $exportService.buildExportUrl(classroomReportingUrl, params);
    };

    self.getClassroomsReporting = function() {
      var params = getClassroomsReportingParams();
      var promises = ClassroomReporting.query(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getClassroom = function(classroom_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      var context = JSON.parse(localStorage.getItem('context'));

      if (context && context.group) {
        // Return minimal promise-like object with empty data when in group context
        if (callback) {
          callback({});
        }

        return {
          $promise: {
            then: function(cb) {
              if (cb) {
                cb({});
              }
              return this;
            },
            catch: function () {
              return this;
            },
            finally: function () {
              return this;
            }
          },
          $resolved: true
        };
      }

      // continues if no group context
      params.classroomId = classroom_id;
      var promises = ClassroomNavigation.get(params);
      promises.$promise.then(callback);

      return promises;
    };

    self.getClassroomsForTeacher = function(teacher_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.teacher_id = teacher_id;
      params.grade_id = $state.params.gradeId;
      // If the customer _is_ the teacher we're querying by, then don't include the school_id param.  This has
      // the effect of allowing _teachers_ to see all classrooms across the district that they're assigned to,
      // and restricting _school admins_ to only see the classrooms for the teacher *and that are in* the school
      // in view.
      if (!$authentication.getCustomer() || $authentication.getCustomer().id !== parseInt(teacher_id)) {
        params.school_id = $state.params.schoolId || undefined;
      }
      var promises = ClassroomNavigation.query(params);
      promises.$promise.then(callback);

      return promises;
    };

    self.getClassroomsForTeacherInDistrict = function(teacher_id, district_id, callback) {
      var params = {districtId: district_id};
      params.teacher_id = teacher_id;
      params.grade_id = $state.params.gradeId;
      // If the customer _is_ the teacher we're querying by, then don't include the school_id param.  This has
      // the effect of allowing _teachers_ to see all classrooms across the district that they're assigned to,
      // and restricting _school admins_ to only see the classrooms for the teacher *and that are in* the school
      // in view.
      if (!$authentication.getCustomer() || $authentication.getCustomer().id !== parseInt(teacher_id)) {
        params.school_id = $state.params.schoolId || undefined;
      }
      var promises = ClassroomNavigation.query(params);
      promises.$promise.then(callback);

      return promises;
    };

    /**
     * Get classroms for a teacher.
     *
     * @param int districtId
     * @param int teacherId
     * @param int schoolId optional restriction by school
     * @param int gradeId optional restriction by grade
     *
     */
    self.getClassroomsForTeacherSubject = function (districtId, teacherId, schoolId, gradeId) {
      var classroomsSubject = new Rx.Subject();

      var params = {
        districtId: districtId,
        teacher_id: teacherId,
        school_id: schoolId,
        grade_id: gradeId
      };

      var resource = ClassroomNavigation.queryNoCache(params);

      // convert promise to Rx.Subject
      resource.$promise.then(function (classrooms) {
        classroomsSubject.onNext(classrooms);
      },
      function (error) {
        classroomsSubject.onError(error);
      });

      return classroomsSubject;
    };

    self.getClassrooms = function(callback) {
      var params = _.pick($state.params, ['districtId']);
      var promises = ClassroomNavigation.query(params);
      promises.$promise.then(callback);

      return promises;
    };

    self.getClassroomsForSchool = function (districtId, schoolId) {
      var params = {
        districtId: districtId,
        school_id: schoolId
      };

      var resource = ClassroomNavigation.queryNoCache(params);
      return resource.$promise;
    };

    self.getClassroomGrades = function(classroom_id, astName) {
      var params = _.pick($state.params, ['districtId']);
      params.classroomId = classroom_id;
      params.school_id = $state.params.schoolId || undefined;
      params.ast = astName;
      params.untilNow = true;

      var promises = $standardsApi.ClassroomGrades.get(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getClassroomDomains = function(classroom_id, grade_id) {
      var params = _.pick($state.params, ['districtId']);
      params.classroomId = classroom_id;
      params.gradeId = grade_id;
      params.untilNow = true;

      var promises = $standardsApi.ClassroomDomains.get(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getClassroomStandardsExportUrl = function() {
      var classroomStandardsUrl = "/r/districts/:districtId/classrooms/:classroomId/standards/all";
      var params = _.pick($state.params, ['districtId', 'classroomId']);
      params.untilNow = true;

      return $exportService.buildExportUrl(classroomStandardsUrl, params, 'xls');
    };

    self.getClassroomStandards = function(classroom_id, grade_id, domain_id) {
      var params = _.pick($state.params, ['districtId']);
      params.classroomId = classroom_id;
      params.gradeId = grade_id;
      params.domainId = domain_id;
      params.untilNow = true;

      var promises = $standardsApi.ClassroomStandards.get(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise;
    };

    self.getClassroomStudents = function(classroom_id, grade_id, domain_id, standard_id) {
      var params = _.pick($state.params, ['districtId']);
      params.classroomId = classroom_id;
      params.gradeId = grade_id;
      params.domainId = domain_id;
      params.standardId = standard_id;
      params.untilNow = true;

      var promises = $standardsApi.ClassroomStudents.get(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);

      return promises.$promise;
    };

    self.getClassroomStudentsCluster = function(classroom_id, grade_id, domain_id, cluster_id) {
      var params = _.pick($state.params, ['districtId']);
      params.classroomId = classroom_id;
      params.gradeId = grade_id;
      params.domainId = domain_id;
      params.clusterId = cluster_id;
      params.untilNow = true;

      var promises = $standardsApi.ClassroomStudentsClusters.get(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);

      return promises.$promise;
    };

    self.getClassroomData = function(classroom_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.classroom_id = classroom_id;
      params.sy = $timeframe.calculateCurrentReportingYear();
      params.untilNow = true;

      var promises = $highlightsApi.ClassroomHighlights.get(params);
      promises.$promise.then(callback);
      return promises;
    };

    self.getClassroomHighlights = function(params) {
      return $highlightsApi.ClassroomHighlights.get(params).$promise;
    };

    self.getClassroomGradeLevels = function(classroom_id, callback) {
      var classroomGradeLevels = [{
        name: 'Pre-K',
        value: 'PreK'
      }, {
        name: 'Kindergarten',
        value: 'Kindergarten'
      }, {
        name: '1st Grade',
        value: '1'
      }, {
        name: '2nd Grade',
        value: '2'
      }, {
        name: '3rd Grade',
        value: '3'
      }, {
        name: '4th Grade',
        value: '4'
      }, {
        name: '5th Grade',
        value: '5'
      }, {
        name: '6th Grade',
        value: '6'
      }, {
        name: '7th Grade',
        value: '7'
      }, {
        name: '8th Grade',
        value: '8'
      }, {
        name: '9th Grade',
        value: '9'
      }, {
        name: '10th Grade',
        value: '10'
      }, {
        name: 'Multi-Grade',
        value: 'MultiGrade'
      }];

      callback(classroomGradeLevels);
    };

    self.getPrimaryTeachers = function() {
      return [{
        name: 'Elle Colburn'
      }, {
        name: 'David Backes'
      }, {
        name: 'James Earl'
      }, {
        name: 'January Jones'
      }, {
        name: 'Kevin Devine'
      }, {
        name: 'Aaron Lanois'
      }];
    };

    /**************************************************************/
    /*                      Settings Api                          */
    /**************************************************************/
    self.getClassroomSettings = function(cid, success, error) {
      var classroomSettings = ClassroomSettings.get({id: cid});

      classroomSettings.$promise.then(function(classroom) {
        classroom.type = 'classroom';
        success(classroom);
      });
      return classroomSettings;
    };

    self.saveClassroomSettings = function(item, success, error) {
      var classroom = new ClassroomSettings(item);
      classroom.$save([], success, error);
    };

    self.getPasswordStyles = function(cid, success, error) {
      var passwordStyles = PasswordStyles.get({id: cid});
      passwordStyles.$promise.then(function(item) {
        item.classroomId = cid;
        item.type = 'classroomPassword';
        success(item);
      });
      return passwordStyles;
    };

    self.savePasswordStyles = function(item, success, error) {
      var payload = {};
      payload.id = item.classroomId;
      payload.authentication_type = item.authentication_type;

      var passwordStyles = new PasswordStyles(payload);
      passwordStyles.$save([], function (result) {
        result.data.classroomId = item.classroomId;
        if (success) {
          success(result);
        }
      }, error);
    };

    self.getClassroomEngagementRestrictions = function(cid, success, error) {
      var classroomEngagement = ClassroomEngagement.classroom({id: cid});
      classroomEngagement.$promise.then(function(roster) {
        roster.classroomId = cid;
        roster.type = 'classroomEngagementRestrictions';
        success(roster);
      });
    };

    self.saveClassroomEngagementRestrictions = function(item, success, error) {
      item.id = item.classroomId;
      var cer = new ClassroomEngagement(item);
      cer.$save([], success, error);
    };
  }]);
  /* jshint +W071 */ // todo: evaluate splitting this service into multiple smaller ones
